






























































































import { Component, Inject, Vue } from "@/shared/vuepack";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import CategoryPill from "@/shared/components/CategoryPill.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import {
  HsabExpenseCategory,
  HsabExpenseCategoryDisplay,
  HsabExpenseOriginator,
  HsabExpenseSubTypeResponse,
  HsabExpenseTypeResponse,
  WexExpenseAccountType
} from "@/shared/types";
import { isNullEmptyOrUndefined, truncateIfTooSmallForWidth } from "@/shared/stringHelper";
import * as hsabExpenseCategoryUtility from "@/employee/Utilities/HsabExpenseCategoryUtility";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import _ from "lodash";
import moment from "moment/moment";
import { Validator } from "vee-validate";
import { useEmployerBankSettingsStore } from "@/shared/store/employerBankSettings";

@Component({
  components: {CategoryPill, GenericLoadingSpinner},
})
export default class HsabExpenseFormExpenseCategory extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();
  hsabExpenseStore = useHsabExpenseStore();
  hsabAccountsStore = useHsabAccountsStore();
  featureFlagStore = useFeatureFlagStore();
  employerBankSettings = useEmployerBankSettingsStore();

  @Inject()
  $validator: Validator;
  mounted () {
    this.$nextTick(() => {

      const loadBankSettingsPromise = this.employerBankSettings.getEmployerBankSettingsForCurrentUser();
      const loadCategoriesPromise = this.hsabExpenseStore.loadExpenseCategories();

      Promise.all([loadBankSettingsPromise, loadCategoriesPromise])
          .then(_ => {
            this.setExpenseCategoryOnMounted();
          }
      );
    });
  }
  get showPlanOptionsInDropdown () {
    return this.hsabAccountsStore.allActiveHsabAccounts.length > 1;
  }
  get categoryPills (): HsabExpenseCategoryDisplay[] {
    const categories = this.hsabExpenseStore.getCategoriesForUsersPlans;

    if (this.hsabExpenseFormStore.isExpenseSubmittedToHsa ||
        (this.hsabExpenseFormStore.expense && this.hsabExpenseFormStore.expense.originator === HsabExpenseOriginator.CarrierClaim)
        || (this.hsabExpenseFormStore.expense && this.hsabExpenseFormStore.expense.originator === HsabExpenseOriginator.DebitCard)
        || (this.hsabExpenseFormStore.expense && this.hsabExpenseFormStore.expense.originator === HsabExpenseOriginator.Disbursement)) {
      return categories.filter(t =>
          t.category === HsabExpenseCategory.Medical ||
          t.category === HsabExpenseCategory.Vision ||
          t.category === HsabExpenseCategory.Dental ||
          t.category === HsabExpenseCategory.Pharmacy);
    }
    return categories;
  }

  setExpenseCategoryOnMounted () {
    if (this.categoryPills.length > 0 && this.hsabExpenseFormStore.hasExpense &&
        isNullEmptyOrUndefined(this.hsabExpenseFormStore.expense.expenseCategory)) {
      // existing expense w/out a category selected
      if (!this.hsabAccountsStore.userHasActiveNotionalAccounts) {
        this.onExpenseCategorySelected(this.categoryPills[0]);
      }
    } else if (this.categoryPills.length > 0 && this.hsabExpenseFormStore.hasExpense &&
        !isNullEmptyOrUndefined(this.hsabExpenseFormStore.expense.expenseCategory)) {
      // existing expense with a category selected
      const currentCat = this.categoryPills.find(x => x.category === this.hsabExpenseFormStore.expense.expenseCategory);
      this.onExpenseCategorySelected(currentCat);

      if (isNullEmptyOrUndefined(this.hsabExpenseFormStore.expense.expenseType)) {
        this.hsabExpenseFormStore.expenseForm.expenseType = currentCat.defaultTypeWhenSelected;
        if (currentCat.defaultSubTypeWhenSelected) {
          const subtypeToSelect = currentCat.defaultSubTypeWhenSelected(this.hsabAccountsStore.accounts);
          this.hsabExpenseFormStore.expenseForm.expenseSubType = subtypeToSelect;
          this.hsabExpenseFormStore.expenseForm.expenseSubTypeDisplayName = subtypeToSelect;
        }
      } else {
        this.hsabExpenseFormStore.expenseForm.expenseType = this.hsabExpenseFormStore.expense.expenseType;
        this.hsabExpenseFormStore.expenseForm.expenseSubType = this.hsabExpenseFormStore.expense.expenseSubType;
        this.hsabExpenseFormStore.expenseForm.expenseSubTypeDisplayName = this.hsabExpenseFormStore.expense.expenseSubTypeDisplayName;
      }

    } else if (this.categoryPills.length > 0 && !this.hsabExpenseFormStore.expense) {
      // new expense form
      if (!this.hsabAccountsStore.userHasActiveNotionalAccounts) {
        this.onExpenseCategorySelected(this.categoryPills[0]);
      }
    }
  }
  onExpenseTypeSelected (expenseType) {
    Vue.set(this.hsabExpenseFormStore.expenseForm, "expenseType", expenseType);
    const selectSubType = this.hsabExpenseFormStore.currentlySelectedCategory.defaultSubTypeWhenSelected &&
    this.hsabExpenseFormStore.currentlySelectedCategory.defaultTypeWhenSelected === expenseType ?
        this.hsabExpenseFormStore.currentlySelectedCategory.defaultSubTypeWhenSelected(this.hsabAccountsStore.accounts) :
        null;

    const subTypes = this.subTypesForCurrentExpenseType;
    if (subTypes.length === 1) {
      this.onExpenseSubTypeSelected(subTypes[0]);
    } else if (selectSubType) {
      this.onExpenseSubTypeSelected({
        subTypeName: selectSubType,
        customDisplayName: selectSubType,
      });
    } else {
      this.onExpenseSubTypeSelected(null);
    }
  }

  onExpenseSubTypeSelected (subType) {
    if (subType) {
      Vue.set(this.hsabExpenseFormStore.expenseForm, "expenseSubType", subType.subTypeName);
      Vue.set(this.hsabExpenseFormStore.expenseForm, "expenseSubTypeDisplayName", subType.customDisplayName);
    } else {
      Vue.set(this.hsabExpenseFormStore.expenseForm, "expenseSubType", "");
      Vue.set(this.hsabExpenseFormStore.expenseForm, "expenseSubTypeDisplayName", "");
    }
  }
  onExpenseCategorySelected (categoryDisplay) {
    if (this.isCategoryDisabled(categoryDisplay)) {
      return;
    }

    this.hsabExpenseFormStore.currentlySelectedCategory = categoryDisplay;
    this.hsabExpenseFormStore.expenseForm.expenseType = null;
    this.hsabExpenseFormStore.expenseForm.expenseSubType = null;

    if (categoryDisplay === undefined || categoryDisplay === null) {
      return;
    }

    this.hsabExpenseFormStore.expenseForm.expenseCategory = categoryDisplay.category;
    if (categoryDisplay.external !== WexExpenseAccountType.Medical) {
      this.hsabExpenseFormStore.isTravelCostReimbursementEnabled = false;
      this.hsabExpenseFormStore.expenseForm.numberOfMiles = null;
    }

    if (!this.isHsaOnly) {
      const expenseTypes = this.expenseTypesForSelectedCategory;

      if (expenseTypes.length === 1) {
        this.onExpenseTypeSelected(expenseTypes[0].expenseType);
      } else if (categoryDisplay.defaultTypeWhenSelected) {
        const shouldSelect = expenseTypes.find(x => x.expenseType === categoryDisplay.defaultTypeWhenSelected);
        if (shouldSelect) {
          this.onExpenseTypeSelected(shouldSelect.expenseType);
        }
      }
    }
  }
  get showExpenseTypeDropdown () {
    return !this.hsabExpenseFormStore.isReadonly
        && !this.hsabExpenseStore.isCategoryDataLoading
        && this.hsabExpenseStore.isCategoryDataLoaded
        && (this.hsabExpenseFormStore.currentlySelectedCategory && this.hsabExpenseFormStore.currentlySelectedCategory.showTypeSelector);
  }

  get showExpenseSubtypeDropdown () {
    return !this.hsabExpenseFormStore.isReadonly && this.hsabExpenseStore.isCategoryDataLoaded && !isNullEmptyOrUndefined(this.hsabExpenseFormStore.expenseForm.expenseType);
  }
  get subTypesForCurrentExpenseType () {
    if (isNullEmptyOrUndefined(this.hsabExpenseFormStore.expenseForm.expenseCategory)
        || isNullEmptyOrUndefined(this.hsabExpenseFormStore.expenseForm.expenseType)) {
      return [];
    }
    const expenseType = this.hsabExpenseStore.getExpenseTypeByCategoryAndType(
        this.hsabExpenseFormStore.expenseForm.expenseCategory,
        this.hsabExpenseFormStore.expenseForm.expenseType);
    if (!expenseType) {
      return [];
    }
    return expenseType.expenseSubTypes;
  }

  get expenseTypesForSelectedCategory () {
    let items = this.hsabExpenseStore.getExpenseTypesAndSubtypesByCategory(this.hsabExpenseFormStore.expenseForm.expenseCategory);
    if (this.hsabExpenseFormStore.expenseForm.expenseCategory === HsabExpenseCategory.Dental || this.hsabExpenseFormStore.expenseForm.expenseCategory === HsabExpenseCategory.Vision) {
      items = hsabExpenseCategoryUtility.removeItemsIfUserHasLimitedFsaPlan(this.hsabAccountsStore.accounts, items);
    }
    return items;
  }
  get expenseTypeDropdownLabel () {
    return this.hsabExpenseFormStore.expenseForm.expenseType ? truncateIfTooSmallForWidth(this.hsabExpenseFormStore.expenseForm.expenseType) : "Select a type";
  }

  get subTypeDropdownLabel () {
    if (this.hsabExpenseFormStore.expenseForm.expenseSubTypeDisplayName) {
      return truncateIfTooSmallForWidth(this.hsabExpenseFormStore.expenseForm.expenseSubTypeDisplayName);
    }
    if (this.hsabExpenseFormStore.expenseForm.expenseSubType) {
      return truncateIfTooSmallForWidth(this.hsabExpenseFormStore.expenseForm.expenseSubType);
    }
    return "Select a subtype";
  }
  get isHsaOnly () {
    const userHasHsa = this.hsabAccountsStore.userHasHsaAccount;
    const userHasNotional = this.hsabAccountsStore.userHasActiveNotionalAccounts;
    return (!userHasNotional && userHasHsa);
  }

  get dateOfServiceAsMoment () {
    return moment(this.hsabExpenseFormStore.expenseForm.dateOfService);
  }
  getPlansEligibleForType (type: HsabExpenseTypeResponse) {
    let plans = [];
    _.forEach(type.expenseSubTypes, x => {
      _.forEach(x.planEligibility, e => {
        const validStart = e.eligibleStartDate === null || this.dateOfServiceAsMoment.isSameOrAfter(e.eligibleStartDate);
        const validEnd = e.eligibleEndDate === null || this.dateOfServiceAsMoment.isSameOrBefore(e.eligibleEndDate);
        if (validStart && validEnd) {
          if (e.isHsa) {
            plans.push("HSA");
          } else {
            plans.push(e.planName);
          }
        }
      });
    });
    plans = _.uniq(plans);

    if (plans.length > 1) {
      return "Multiple Plan Options";
    } else if (plans.length > 0) {
      return plans[0];
    } else {
      return "Unknown";
    }
  }

  isCategoryDisabled (categoryDisplay: HsabExpenseCategoryDisplay): boolean {
    if (this.hsabExpenseFormStore.isFutureDatedExpense) {
      return categoryDisplay.category !== HsabExpenseCategory.DependentCare;
    }

    return false;
  }

  getCategoryPillTitle (categoryDisplay): string {
    if (this.hsabExpenseFormStore.isFutureDatedExpense) {
      return categoryDisplay.category !== HsabExpenseCategory.DependentCare ? "Cannot be selected with a future dated expense" : "";
    }

    return "";
  }
  getPlansEligibleForSubType (subtype: HsabExpenseSubTypeResponse) {
    let plans = [];
    _.forEach(subtype.planEligibility, e => {
      const validStart = e.eligibleStartDate === null || this.dateOfServiceAsMoment.isSameOrAfter(e.eligibleStartDate);
      const validEnd = e.eligibleEndDate === null || this.dateOfServiceAsMoment.isSameOrBefore(e.eligibleEndDate);
      if (validStart && validEnd) {
        if (e.isHsa) {
          plans.push("HSA");
        } else {
          plans.push(e.planName);
        }
      }
    });
    plans = _.uniq(plans);

    if (plans.length > 1) {
      return "Multiple Plan Options";
    } else if (plans.length > 0) {
      return plans[0];
    } else {
      return "Unknown";
    }
  }
}
